import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, Label } from '@atlas/ui';

export const InstructionPopup = ({ data, id }) => {
  const {
    buttonText = null,
    paymentName = '',
    redirectUrl,
    stepsPreText = null,
    stepsText = null,
    text = null,
    title = null,
  } = data;

  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <DefaultPopup
      className="deposit-instruction"
      headerTitle={title}
      headerTitlePosition="left"
      onClose={handleClose}
      postHeaderTitle={paymentName}
    >
      <div className="deposit-instruction__content">
        <Label className="deposit-instruction__text deposit-instruction__margin" message={text} />
        <div>
          <Label
            className="deposit-instruction__text-semibold deposit-instruction__margin"
            message={stepsPreText}
          />
          {stepsText && (
            <ul>
              {stepsText.map(({ step_instruction, step_number }) => (
                <li
                  className="deposit-instruction__description-item deposit-instruction__margin"
                  key={step_number}
                >
                  <span className="deposit-instruction__description-item-number deposit-instruction__text">
                    {step_number}
                  </span>
                  <span className="deposit-instruction__text">{step_instruction}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        {!!redirectUrl && !!buttonText && (
          <Button className="deposit-instruction__button" label={buttonText} size="big">
            <a
              className="deposit-instruction__button-link"
              href={redirectUrl}
              rel="noreferrer"
              target="_blank"
            />
          </Button>
        )}
      </div>
    </DefaultPopup>
  );
};

InstructionPopup.propTypes = {
  data: PropTypes.shape({
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    paymentName: PropTypes.string,
    redirectUrl: PropTypes.string,
    stepsPreText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    stepsText: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
